module.exports = __webpack_public_path__ + "static/img/bg-en.3bac825a.webp";